<div mat-dialog-content class="cmc-dialog-sm">
  @if (!data.type) {
    <h4>{{ 'board.appointments.header_upload_document' | translate }}</h4>
  }
  @if (data.type === 'board_agenda') {
    <h4>{{ 'board.appointments.header_upload_agenda' | translate }}</h4>
  }
  @if (data.type === 'board_minutes') {
    <h4>{{ 'board.appointments.header_upload_minutes' | translate }}</h4>
  }

  <img class="cmc-dialog-image" alt="" src="assets/images/theme/board/upload.png" alt="Exemplary image">

  <div class="font-italic f-s-12">
    <p>{{ 'board.appointments.info_upload_document' | translate }}{{ data.meeting.date | date: 'dd.MM.yyyy' }}</p>
  </div>

  @if (!data.type) {
    <div class="row">
      <div class="col">
        <mat-form-field appearance="fill" color="primary" class="mat-form-field">
          <mat-label>{{ 'board.appointments.label_type' | translate }}</mat-label>
          <select matNativeControl required [formControl]="type" (focusout)="validateInputs()">
            <option value="board_agenda>">{{ 'file_type.board_agenda' | translate }}</option>
            <option value="board_minutes">{{ 'file_type.board_minutes' | translate }}</option>
            <option value="board_minutes_attachment">{{ 'file_type.board_minutes_attachment' | translate }}</option>
          </select>
        </mat-form-field>
      </div>
    </div>
  }

  @if (type.value != 'board_agenda' && type.value != 'board_minutes') {
    <div class="row m-t-4 m-b-8">
      <div class="col-12">
        <mat-form-field appearance="fill" class="mat-form-field">
          <mat-label>{{ 'board.appointments.label_title' | translate }}</mat-label>
          <input matInput [formControl]="title" (focusout)="validateInputs()"
                 (keydown)="validateInputs()" class="w-full f-s-12">
          @if (title.invalid) {
            <mat-error>{{ getTitleErrorMessage() }}</mat-error>
          }
        </mat-form-field>
      </div>
    </div>
  }

  <div class="row m-t-4 m-b-8">
    <div class="col-12 p-8">

      <input type="file" class="file-input d-none"
             (change)="onFileSelected($event)" #fileUpload>

      <div class="cmc-file-pick">

        {{ fileName || ('member.files.dialog_info_no_file_selected' | translate) }}

        <button mat-mini-fab color="primary" class="upload-btn m-l-24"
                (click)="fileUpload.click()">
          <mat-icon>attach_file</mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>


<mat-divider />

@if (errorMessage) {
  <div>
    <span class="text-danger"><mat-icon>error</mat-icon>
      {{ this.errorMessage }}</span>
  </div>
}
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">{{ 'common.abort' | translate }}
  </button>
  <div class="toolbar-spacer"></div>
  <button mat-raised-button color="primary"
          [disabled]="!isValid" (click)="uploadFile()">
    {{ 'common.apply' | translate }}
  </button>
</div>
